import {createUseStyles} from 'react-jss';

export default  createUseStyles({
    map:{
        position:'relative',
        width: '100%',
        height: '100%',
    },
});
